import { render, staticRenderFns } from "./PcPcmClamTable.vue?vue&type=template&id=4d9ff15b&"
import script from "./PcPcmClamTable.vue?vue&type=script&lang=js&"
export * from "./PcPcmClamTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports